<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}

ul,
li {
  list-style: none;
}

.perCenter {
  //width: 1240px;
  // background: #f1f0f0;
  margin: 0 auto;
  //padding: 30px;
  display: flex;

  .load {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(50%, 50%);
  }

  .userinfo {
    background-color: #FFFFFF;
    width: 180px;
    border-radius: 8px 8px 0px 0px;
    padding-top: 30px;
    padding-bottom: 60px;

    .icon {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      display: block;
      margin: 0px auto 20px auto;
      object-fit: cover;
    }

    .name {
      width: 180px;
      font-size: 16px;
      color: #040506;
      text-align: center;
      display: block;

      .gendar {
        width: 18px;
        height: 18px;
        margin-bottom: 4px;
      }
    }
  }

  .sideLeft {
    width: 180px;
    text-align: center;
    height: 650px;
    border-radius: 0px 0px 8px 8px;

    .siderBarName {
      font-size: 20px;
      color: #040506;
      font-weight: normal;
      font-stretch: normal;
    }

    .icon {
      width: 28px;
      height: 28px;
    }
  }

  // 班级列表
  .list {
    // overflow-y: scroll;
    height: calc(100vh - 300px);
    // min-height: 630px;
    //height: 700px;
    //height: 100%;
    font-size: 16px;
    width: 180px;
    text-align: center;
    background: #FFFFFF;
    border-radius: 0px 0px 8px 8px;

    .group {
      // padding: 15px 30px;
      border-bottom: dotted 1px #eee;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      display: flex;
      justify-content: center;
      cursor: pointer;
      height: 60px;
      padding-top: 15px;
    }

    .group:hover {
      color: @primary-color;
    }

    .active {
      background-color: #FFF5F5;
      color: @primary-color;
      border-left: 4px solid @primary-color;
      border-bottom: dotted 1px #eee;
      font-size: 18px;
      font-weight: bold;
      cursor: pointer;
      display: flex;
      justify-content: center;
      text-align: center;
      height: 60px;
      padding-top: 15px;
    }

    .siderBarName {
      font-size: 18px;
      color: #040506;
      font-weight: normal;
      font-stretch: normal;
      text-align: center;
      margin-left: 10px;
    }

    .siderBarNameselect {
      font-size: 20px;
      color: @primary-color;
      font-weight: normal;
      font-stretch: normal;
      text-align: center;
      margin-left: 10px;
    }

    .icon {
      width: 22px;
      height: 22px;
      margin-top: 4px;
    }

    .icon-other {
      width: 25px;
      height: 25px;
      margin-top: 2px;
    }
  }

  .contentMes {
    //width: 980px;
    height: 100%;
    background: #fff;
    margin-left: 0px;
    border-radius: 8px;
  }
}

.ant-layout-sider {
  background: rgb(246, 246, 246);
}

.ant-menu-item {
  height: 80px !important;
  line-height: 80px !important;
}

.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background: #f7f5f0;
}

.ant-menu-vertical .ant-menu-item::after,
.ant-menu-vertical-left .ant-menu-item::after,
.ant-menu-vertical-right .ant-menu-item::after,
.ant-menu-inline .ant-menu-item::after {
  // border-left: 3px solid #ff9a4a;
  border-right: none;
}

.ant-menu-vertical .ant-menu-item,
.ant-menu-vertical-left .ant-menu-item,
.ant-menu-vertical-right .ant-menu-item,
.ant-menu-inline .ant-menu-item,
.ant-menu-vertical .ant-menu-submenu-title,
.ant-menu-vertical-left .ant-menu-submenu-title,
.ant-menu-vertical-right .ant-menu-submenu-title,
.ant-menu-inline .ant-menu-submenu-title {
  margin-top: 0px;
}
</style>
<template>
  <div class="perCenter">
    <a-spin class="load" v-show="load"/>
    <a-layout>
      <a-layout-sider>
        <div class="userinfo">
          <img class="icon"
               :src="$store.getters.userPhoto&&$store.getters.userPhoto!=null?$store.getters.userPhoto:mrPhoto"
               alt="">
          <span class="name">
          {{ userName }}
             <img class="gendar" src="../../assets/imgs/Female.png" v-show="gender===0"/>
             <img class="gendar" src="../../assets/imgs/male.png" v-show="gender===1"/>
        </span>

        </div>
        <!--        <a-menu class="sideLeft"-->
        <!--                :default-selected-keys="[id]"-->
        <!--                :default-open-keys="['我的资源库']"-->
        <!--                theme="light"-->
        <!--                mode="inline">-->
        <!--          <a-menu-item v-for="item in this.classList" :key="item.id">-->
        <!--            <router-link :to="{ name: item.text }">-->
        <!--              <img class="icon" src="../../assets/imgs/Female.png" v-show="item.id===0&&id===0"/>-->
        <!--              <img class="icon" src="../../assets/imgs/male.png" v-show="item.id===0&&id!==0"/>-->
        <!--              <a-icon type="solution" v-show="item.id===1" style="font-size: 24px"/>-->
        <!--              <a-icon type="safety" v-show="item.id===5" style="font-size: 24px"/>-->
        <!--              <span class="siderBarName">{{ item.name }}</span>-->
        <!--            </router-link>-->
        <!--          </a-menu-item>-->
        <!--        </a-menu>-->

        <div class="list" v-if="classList!==null&&classList.length>0">
          <div v-for="(c,index) in classList" :key="index" :class="c.text===currentPath ? 'active' : 'group'"
               @click="changeClass(c,c.id)">
            <!--            <router-link :to="{ name: c.text }">-->
            <img class="icon" src="../../assets/imgs/my-res-select.png" v-show="c.id===0&&c.text===currentPath"/>
            <img class="icon" src="../../assets/imgs/my-res.png" v-show="c.id===0&&c.text!==currentPath"/>
            <img class="icon" src="../../assets/imgs/my-persion-select.png" v-show="c.id===1&&c.text===currentPath"/>
            <img class="icon" src="../../assets/imgs/my-persion.png" v-show="c.id===1&&c.text!==currentPath"/>
            <img class="icon" src="../../assets/imgs/my-password-select.png" v-show="c.id===2&&c.text===currentPath"/>
            <img class="icon" src="../../assets/imgs/my-password.png" v-show="c.id===2&&c.text!==currentPath"/>
            <img class="icon" src="../../assets/imgs/my-order-selected.png" v-show="c.id===3&&c.text===currentPath"/>
            <img class="icon" src="../../assets/imgs/my-order.png" v-show="c.id===3&&c.text!==currentPath"/>
            <span :class="{ siderBarName: c.text!==currentPath, siderBarNameselect: c.text===currentPath }">{{
                c.name
              }}</span>
            <!--            </router-link>-->
          </div>
        </div>
      </a-layout-sider>
      <a-layout-content>
        <div class="contentMes">
          <router-view></router-view>
        </div>
      </a-layout-content>
    </a-layout>
  </div>
</template>

<script>
// import contactsPeople from './Contacts'
export default {
  name: 'Class',
  components: {
    // contactsPeople
  },
  // computed: {
  //   userName () {
  //     return this.$store.getters.userInfo.name // 监听Vuex状态的变化
  //   },
  //   gender () {
  //     return this.$store.getters.userInfo.gender // 监听Vuex状态的变化
  //   }
  // },
  data() {
    return {
      id: 0,
      currentGroupIndex: 0,
      currentPath: '',
      userName: this.$store.getters.userInfo.name,
      gender: this.$store.getters.userInfo.gender,
      load: false,
      classList: [
        {text: '/personal-center/my-library', name: '我的资源', id: 0},
        {text: '/personal-center/my-info', name: '个人信息', id: 1},
        // { text: 'MyBooks', name: '我的教材', id: 2 },
        // { text: 'MyCredits', name: '我的积分', id: 3 },
        // { text: 'MyHistory', name: '消息通知', id: 4 }
        {text: '/personal-center/my-passWord', name: '密码管理', id: 2},
        {text: '/personal-center/my-order', name: '我的订单', id: 3}
      ],
      mrPhoto: require('../../assets/imgs/teacher.png')
    }
  },
  mounted() {
    // const userInfo = window.localStorage.getItem('user_info')
    // window.postMessage(userInfo, '*')
    // this.$router.push({ name: 'MyInfo' })
    // this.$router.push('/personal-center/my-library')
    this.currentPath = this.$route.path
    console.log(this.currentPath)
    this.userName = this.$store.getters.userInfo.name
    this.gender = this.$store.getters.userInfo.gender
  },
  methods: {
    changeClass(classMess, index) {
      this.currentGroupIndex = index
      this.currentPath = classMess.text
      console.log(index)
      console.log(this.currentPath)
      this.$router.push(classMess.text)
    }
  }
}
</script>
